/* eslint-disable */
import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_LOYLATITY_CUSTOMER_DETAIL, SET_LOYLATITY_CUSTOMER_DETAIL } from '../actions';
import { appId, apiUrl, deliveryId } from "../components/Helpers/Config";
import Axios from 'axios';
import cookie from 'react-cookies';


export const watchGetLoyaltyCustomerDetail = function* () {
  yield takeEvery(GET_LOYLATITY_CUSTOMER_DETAIL, workerGetLoyaltyCustomerDetail);
}

function* workerGetLoyaltyCustomerDetail({ params }) {
  try {
    const uri = apiUrl+'/chopchop/customer/loyaltycustomerdetail?'+params;
    const result = yield call(Axios.get, uri);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_LOYLATITY_CUSTOMER_DETAIL, value: resultArr });
  } 
  catch {
    console.log('Get Customer Failed');
  }
} 

